import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromContacts from './+state/contacts.reducer';
import { ContactsEffects } from './+state/contacts.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromContacts.CONTACTS_FEATURE_KEY,
      fromContacts.contactsReducer
    ),
    EffectsModule.forFeature([ContactsEffects]),
  ],
  providers: [],
})
export class SharedDataAccessContactsModule {}
